import { setupDash0Tracing, initDash0Sdk } from './utils/tracing'

setupDash0Tracing()

if (initDash0Sdk()) {
  console.log('Dash0 SDK initialization attempted (management)')
}

import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'

// A deploy deletes the previous build's hashed chunks, so a tab opened before it fails to
// lazy-load them. Reload once to pick up the new index.html; the guard prevents a reload loop.
const PRELOAD_RELOAD_KEY = 'vite-preload-reloaded-at'
window.addEventListener('vite:preloadError', (event) => {
  let last = 0
  try {
    last = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY)) || 0
  } catch {
    // sessionStorage unavailable: fall through and reload anyway
  }
  if (Date.now() - last < 10_000) return
  event.preventDefault()
  try {
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()))
  } catch {
    // ignore
  }
  window.location.reload()
})

const originalPushState = history.pushState
const originalReplaceState = history.replaceState

history.pushState = function (state: unknown, title: string, url?: string | URL | null) {
  originalPushState.call(this, state, title, url)
  window.dispatchEvent(new Event('popstate'))
}

history.replaceState = function (state: unknown, title: string, url?: string | URL | null) {
  originalReplaceState.call(this, state, title, url)
  window.dispatchEvent(new Event('popstate'))
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
